import { UnoSettingsSection } from "@/components/admin/uno/uno-settings-section.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/settings/org/uno")({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.uno_settings_title()) }],
	}),
});

function RouteComponent() {
	return <UnoSettingsSection />;
}
